import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';

const tags = {
  getCommissions: 'getCommissions',
  setFiatCommission: 'setFiatCommission',
  setCryptoCommission: 'setCryptoCommission',
  updateCryptoCommission: 'updateCryptoCommission',
  deleteCommission: 'deleteCommission',
  getFiatAssets: 'getFiatAssets',
  getPrice: 'getPrice',
};

export const commissionsApi = createApi({
  reducerPath: 'commissionsApi',
  tagTypes: [tags.getCommissions],
  endpoints: (builder) => ({
    getFiatAssets: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/fiat-assets`,
        });
      },
      providesTags: [tags.getFiatAssets],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    getCommissions: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/commission/list`,
        });
      },
      providesTags: [tags.getCommissions],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    setFiatCommission: builder.mutation({
      query: ({ id, baseAsset, quoteAsset, unitType, amount, side, minLimit, maxLimit }) => {
        const body = {
          'base_asset': baseAsset,
          'quote_asset': quoteAsset,
          'commission_type': 'CONVERT',
          'transaction_type': null,
          'unit_type': unitType,
          'amount': amount,
          'side': side,
          'min_limit': minLimit || '-1',
          'max_limit': maxLimit || '-1',
        };

        if (id) {
          body.id = id;
        }
        return ({
          method: 'post', url: `/commission/set-commission`,
          body: body,
        });
      },
      providesTags: [tags.setFiatCommission],
      invalidatesTags: [tags.getCommissions],
    }),
    setCryptoCommission: builder.mutation({
      query: ({ unitType, amount }) => {
        return ({
          method: 'post', url: `/commission/set-default-commission`,
          body: {
            'unit_type': unitType,
            'amount': amount,
            'min_limit': -1,
            'max_limit': -1,
          },
        });
      },
      providesTags: [tags.setCryptoCommission],
      invalidatesTags: [tags.getCommissions],
    }),
    updateCryptoCommission: builder.mutation({
      query: ({ id,unitType, amount }) => {
        return ({
          method: 'patch', url: `/commission/update-default-commission`,
          body: {
            'id': id,
            'unit_type': unitType,
            'amount': amount,
          },
        });
      },
      providesTags: [tags.updateCryptoCommission],
      invalidatesTags: [tags.getCommissions],
    }),
    deleteCommission: builder.mutation({
      query: ({ id }) => {
        return ({
          method: 'delete', url: `/commission/delete-commission?commission_id=${id}`,
        });
      },
      providesTags: [tags.deleteCommission],
      invalidatesTags: [tags.getCommissions],
    }),
    getPrice: builder.mutation({
      query: ({ baseAsset, quoteAsset, side }) => {
        return ({
          method: 'post', url: `/admin/price`,
          body: {
            'base_asset': baseAsset,
            'quote_asset': quoteAsset,
            side
          }
        });
      },
      providesTags: [tags.getPrice],
    }),
  }),
});

export const commissionsParams = createSlice({
  name: 'commissionsParams',
  initialState: {
    page: 1,
    limit: 100,
    filter: 'ALL',
    start: new Date(new Date().setDate(0)),
    end: new Date(),
  },
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },

  },
});
export const {
  useGetCommissionsQuery,
  useUpdateCryptoCommissionMutation,
  useSetFiatCommissionMutation,
  useDeleteCommissionMutation,
  useSetCryptoCommissionMutation,
  useGetFiatAssetsQuery,
  useGetPriceMutation
} = commissionsApi;

export const { setParams } = commissionsParams.actions;
export const commissionsParamsReducer = commissionsParams.reducer;
export const commissionsParamsSelector = (state) => state.commissionsParams;